(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      if (!motion.matches) entry.target.classList.add('f5-enter');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.08 }) : null;
  function refresh(root = document) {
    root.querySelectorAll('.f5 .package, .f5 .custom-grid article, .f5 .three > div, .f5 .four > div, .f5 .note, .f5 .custom-callout').forEach(element => {
      if (seen.has(element) || !observer) return;
      seen.add(element);
      observer.observe(element);
    });
  }
  refresh();
  document.addEventListener('shopify:section:load', event => refresh(event.target));
})();
